import type { DialogueOfferMessage } from 'components/Dialogue/types';
import { BaseMsgProps } from './types';
import LazyOfferMessage from '../LazyOfferMessage';
import { getMetaFromSender } from '../../utils';
import QuoteMessage from '../QuoteMessage';
import { useChatContext } from '../../contexts/ChatContext';
import { MessageStatusDecorate } from '../MessageStatusDecorate';
import { MessageExtend } from '../MessageExtend';
import { memo } from 'react';

export const OfferMsg = memo((props: BaseMsgProps) => {
  const { msg, raw, conversation } = props;
  const { clickQuote, dialogRef } = useChatContext();

  const { conversationId, storeId, topBarInfo } = conversation;
  const { msgId, externalId, failCause } = raw;
  const { sender } = msg;
  const msgContent = (msg as DialogueOfferMessage).content;

  const { isBuyerMessage } = getMetaFromSender(sender);

  return msgContent ? (
    <LazyOfferMessage
      rawMsg={msg.raw}
      conversationId={conversationId}
      conversation={conversation}
      storeId={storeId}
      msgId={msgId}
      externalMsgId={externalId}
      externalItemId={`${msgContent.productId}`}
      externalStoreId={msg.raw.offerContent?.externalStoreId || ''}
      msgContent={msgContent}
      isBuyerMessage={isBuyerMessage}
      quote={
        <QuoteMessage message={raw} storeName={topBarInfo?.storeName} onQuoteClick={clickQuote} />
      }
      lazyScrollContainer={dialogRef?.dom}
    >
      {(component) => {
        return (
          <MessageExtend
            raw={raw}
            msg={msg}
            conversation={conversation}
            content={
              <MessageStatusDecorate
                message={raw}
                status={msg?.status}
                content={component}
                failCause={failCause}
                dialogRef={dialogRef}
              />
            }
          />
        );
      }}
    </LazyOfferMessage>
  ) : null;
});
